import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { TokenService } from '../token.service';

@Injectable()
export class AuthenticationGuardService implements CanActivate {
  constructor(private tokenService: TokenService, private router: Router) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this.tokenService.isAuthTokenValid() || route.url.toString().indexOf('bce-home') !== -1){
      return true;
    } else {
      if (this.tokenService.isRefreshTokenValid()){

        await this.tokenService.refreshAuthToken()
                               .then();

        if (this.tokenService.isAuthTokenValid()){
          return true;
        }
      }
    }

    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
    return false;
  }
}
